/* eslint-disable camelcase, @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
import Cookies from 'universal-cookie';
// @ts-ignore
import Form from 'react-validation/build/form';
// @ts-ignore
import Button from 'react-validation/build/button';
import {
    email as emailValidator,
    fullName as fullNameValidator,
    phone as phoneValidator,
    postcode as postcodeValidator,
    required,
} from '../../common/ValidationRules';
import { ValidationInput } from '../../common/ValidationInput';
import ValidationSelect from '../../common/ValidationSelect';
import { ErrorMessage } from '../../common';
import { signup } from '../../../actions/ClientData';
import { toggleModal } from '../../../actions/ViewController';
import { SERVER_URL } from '../../../config';
import { LOGO } from './const';
import { validateForm } from './validateForm';
import { executeHttpRequest } from '../../../epics/api';

import history from '../../../history';
import { modalTypes } from '../../../consts';
import { TCategoryChoice } from '../../../types';

const cookies = new Cookies();


export default function SignUp() {
    const dispatch = useDispatch();

    const [logo, setLogo] = useState(null);
    const [previewLogoUrl, setPreviewLogoUrl] = useState(null);
    const [fullName, setFullName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [category, setCategory] = useState(null);
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [billingAddress1, setBillingAddress1] = useState('');
    const [billingAddress2, setBillingAddress2] = useState('');
    const [billingCity, setBillingCity] = useState('');
    const [billingPostcode, setBillingPostcode] = useState('');

    const [clientCategoriesOptions, setClientCategoriesOptions] = useState([]);
    const [categoryError, setCategoryError] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const formRef = useRef(null);
    const fullNameInputRef = useRef(null);
    const companyInputRef = useRef(null);
    const mobileInputRef = useRef(null);
    const emailInputRef = useRef(null);
    const passwordInputRef = useRef(null);
    const billingAddress1InputRef = useRef(null);
    const billingAddress2InputRef = useRef(null);
    const billingCityInputRef = useRef(null);
    const billingPostcodeInputRef = useRef(null);
    const errorMessageDiv = useRef(null);

    const fetchClientCategories = () => executeHttpRequest('client-categories/')
        .then(res => {
            const categoryChoices = res.data.content.map(
                (choice: TCategoryChoice) => ({
                    value: choice.id,
                    label: choice.category,
                })
            );
            if (categoryChoices) {
                setClientCategoriesOptions(categoryChoices);
            }
        });

    useEffect(() => {
        fetchClientCategories();
    }, []);

    const handleLogin = () => {
        dispatch(toggleModal('authModal', modalTypes.LOGIN));
    };

    const handleContinue = () => {
        setLoading(true);
        setCategoryError(null);

        const formSignUpID = document.getElementById('signup-form');
        // @ts-ignore
        const formData = new FormData(formSignUpID);

        const [first_name, ...last_name] = fullName.toString().split(' ');
        formData.append('first_name', first_name);
        formData.append('last_name', last_name.join(' '));
        formData.delete('fullName');

        if (logo) formData.append(LOGO, logo, LOGO);

        if (cookies.get('agency')) formData.append('agency', cookies.get('agency'));

        if (cookies.get('ref')) formData.append('referral_source', cookies.get('ref'));

        // @ts-ignore
        const rawData = Object.fromEntries(formData);

        dispatch(signup(formData, rawData, (response: any, err: any) => {
            if (response && !err) {
                history.push('/job/create?signup=1');
                return;
            }

            const fieldsRefs = {
                first_name: fullNameInputRef.current,
                last_name: fullNameInputRef.current,
                company_name: companyInputRef.current,
                mobile: mobileInputRef.current,
                email: emailInputRef.current,
                password: passwordInputRef.current,
                billing_address_1: billingAddress1InputRef.current,
                billing_address_2: billingAddress2InputRef.current,
                billing_city: billingCityInputRef.current,
                billing_postcode: billingPostcodeInputRef.current,
            };

            const errorMessage = validateForm(
                formRef.current,
                fieldsRefs,
                err,
                true,
                errorMessageDiv.current,
            );

            if (err?.data?.meta?.detail?.category) {
                setCategoryError(err.data.meta.detail.category.join(' '));
            }

            setError(errorMessage);
            setLoading(false);
        }));
    };

    const handleClickLogo = (e: any) => {
        e.preventDefault();

        document.getElementById(LOGO).click();
    };

    const handleChangeLogo = (e: any) => {
        const file = e.target.files?.[0];
        if (file) {
            setLogo(file);
            const reader = new FileReader();
            reader.onloadend = () => setPreviewLogoUrl(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleGoBack = (e: any) => {
        e.preventDefault();

        const { pathname } = history.location;

        if (pathname === '/client') {
            dispatch(toggleModal('authModal', modalTypes.LOGIN));
        } else if (pathname === '/') {
            dispatch(toggleModal('authModal', modalTypes.LOGIN));
        } else {
            dispatch(toggleModal('authModal', null));
            history.goBack();
        }
    };

    const renderTermsAndConditions = () =>
        <>
            By clicking on &ldquo;Continue&rdquo;, you agree to the{' '}
            <a
                target="_blank"
                href={`${SERVER_URL}/client/terms-and-conditions/`}
                rel="noreferrer"
            >
                Supply of Agency Workers and Hirer User Agreement for Berry Recruitment Apps
            </a>
            .
        </>;

    return (
        <Modal
            className="signup-modal auth-form"
            contentLabel="SignUp Modal"
            isOpen={true}
        >
            <p className="modal-title">Sign up</p>
            <div className="modal-content">
                <input
                    id="logo"
                    name="logo"
                    type="file"
                    accept="image/*"
                    onChange={handleChangeLogo}
                    hidden={true}
                />
                <Form
                    id="signup-form"
                    ref={formRef}
                    disabled={loading}
                    onSubmit={(e: any) => e.preventDefault()}
                >
                    <button
                        className="btn-logo input--round"
                        onClick={handleClickLogo}
                        type="button"
                    >
                        <i className="icon icon-upload-harddrive-1"/>
                        <br/>
                        Logo
                        <div className="logo-thumb">
                            {previewLogoUrl &&
                                <img src={previewLogoUrl} alt="Logo"/>
                            }
                        </div>
                    </button>
                    <ValidationInput
                        type="text"
                        name="fullName"
                        value={fullName}
                        className="first-name input--round"
                        placeholder="Full name"
                        ref={fullNameInputRef}
                        containerClassName="firstname-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setFullName(e.target.value)}
                        validations={[required, fullNameValidator]}
                    />
                    <ValidationInput
                        type="text"
                        name="company_name"
                        value={companyName}
                        className="company input--round"
                        placeholder="Company name"
                        ref={companyInputRef}
                        containerClassName="company-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setCompanyName(e.target.value)}
                        validations={[required]}
                    />
                    <ValidationSelect
                        containerClassName="input-wrapper"
                        error={categoryError}
                        errorClassName="input--invalid"
                        name="category"
                        className="client-category"
                        placeholder="Company type"
                        value={category}
                        clearable={false}
                        onChange={(e: any) => {
                            setCategory(e);
                            setCategoryError(null);
                        }}
                        options={clientCategoriesOptions}
                    />
                    <ValidationInput
                        type="tel"
                        name="mobile"
                        maxLength={11}
                        value={mobile}
                        className="mobile input--round"
                        placeholder="Phone number"
                        ref={mobileInputRef}
                        containerClassName="mobile-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setMobile(e.target.value)}
                        validations={[required, phoneValidator]}
                    />
                    <ValidationInput
                        type="email"
                        name="email"
                        value={email}
                        className="email input--round"
                        placeholder="Email address"
                        ref={emailInputRef}
                        containerClassName="email-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        validations={[required, emailValidator]}
                        onChange={(e: any) => setEmail(e.target.value)}
                    />
                    <ValidationInput
                        type="password"
                        name="password"
                        value={password}
                        className="password input--round"
                        placeholder="Create a password"
                        ref={passwordInputRef}
                        containerClassName="password-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setPassword(e.target.value)}
                        validations={[required]}
                    />
                    <ValidationInput
                        type="text"
                        name="billing_address_1"
                        value={billingAddress1}
                        className="input--round"
                        placeholder="Address 1"
                        ref={billingAddress1InputRef}
                        containerClassName="address-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setBillingAddress1(e.target.value)}
                        validations={[required]}
                    />
                    <ValidationInput
                        type="text"
                        name="billing_address_2"
                        value={billingAddress2}
                        className="input--round"
                        placeholder="Address 2"
                        ref={billingAddress2InputRef}
                        containerClassName="address-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setBillingAddress2(e.target.value)}
                    />
                    <ValidationInput
                        type="text"
                        name="billing_city"
                        value={billingCity}
                        className="input--round"
                        placeholder="City"
                        ref={billingCityInputRef}
                        containerClassName="city-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setBillingCity(e.target.value)}
                        validations={[required]}
                    />
                    <ValidationInput
                        type="text"
                        name="billing_postcode"
                        value={billingPostcode}
                        className="input--round"
                        placeholder="Postcode"
                        ref={billingPostcodeInputRef}
                        containerClassName="postcode-wrapper input-wrapper"
                        errorClassName="input--invalid"
                        onChange={(e: any) => setBillingPostcode(e.target.value)}
                        validations={[required, postcodeValidator]}
                    />
                    <div className="visible-xs">
                        <p className="option-secondary">
                            {renderTermsAndConditions()}
                        </p>
                        <Button
                            className="continue"
                            onClick={handleContinue}
                        >
                            CONTINUE
                        </Button>
                    </div>
                    <p className="option">
                        Already have an account?{' '}
                        <a
                            className="nowrap-white-space"
                            onClick={handleLogin}
                        >
                            Log in now
                        </a>
                    </p>
                    <p className="option-secondary hidden-xs">
                        {renderTermsAndConditions()}
                    </p>
                    <div className="hidden-xs">
                        <Button
                            disabled={loading}
                            className="continue btn--round-big"
                            onClick={handleContinue}
                        >
                            CONTINUE
                        </Button>
                        <button
                            className="back"
                            onClick={handleGoBack}
                            type="button"
                        >
                            GO BACK
                        </button>
                    </div>
                </Form>
            </div>
            {error &&
                <div ref={errorMessageDiv}>
                    <ErrorMessage message={error} />
                </div>
            }
        </Modal>
    );

}
